export const getFilenameFromContentDisposition = (
  contentDisposition: string,
  defaultFilename: string = 'exported_file.pdf',
) => {
  // Example contentDisposition: 'attachment; filename=\"Materials List.pdf\"; filename*=UTF-8''Materials%20List.pdf'

  if (!contentDisposition) return defaultFilename;

  const utf8FilenameMatch = contentDisposition.match(
    /filename\*=\s*UTF-8''([^;]+)/,
  );
  if (utf8FilenameMatch && utf8FilenameMatch.length > 1) {
    const filename = utf8FilenameMatch[1];
    // If the filename is longer than 4 characters (.pdf), it's probably a valid filename
    if (filename.length > 4 && filename[0] !== '.') {
      return decodeURIComponent(filename);
    }
  }

  // Fallback to defualt filename
  return defaultFilename;
};
